import { combineReducers } from 'redux';

import selection from './selection/reducer';

export default combineReducers({ selection });



// WEBPACK FOOTER //
// ./src/pages/verificationselection/state/reducer.js